import './HvacFormAspectRatioBody.scss';
import React, { memo } from 'react';
import { FormattedMessage } from 'src/migration/react-intl';
import { Button } from 'src/modules/common/components/Button';
import { HelperText01 } from 'src/modules/common/typography/HelperText01';
import { HvacSchemaAspectRatio } from 'src/modules/hvac/types/HvacSchemaAspectRatio';

type Props = {
  readonly setAspectRatio: (aspect: HvacSchemaAspectRatio) => void;
};

export const HvacFormAspectRatioBody = memo(({ setAspectRatio }: Props) => (
  <div className="bp-hvac-form-aspect-ratio-body">
    <HelperText01>
      <FormattedMessage id="hvac/schema/aspect"/>
    </HelperText01>

    <div className="bp-hvac-form-aspect-ratio-body__ratios">
      <Button kind="ghost" size="sm" iconOnly={true} onClick={() => setAspectRatio(HvacSchemaAspectRatio.HALF)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="24"
          fill="none"
        >
          <path
            stroke="#2C2B2B"
            strokeWidth="2"
            d="M31 1v22H1V1h30Z"
          />

          <path
            fill="#C3C3C3"
            d="M4 4h11v16H4V4Z"
          />

          <path
            fill="#2C2B2B"
            d="M17 4h11v16H17V4Z"
          />
        </svg>
      </Button>

      <Button kind="ghost" size="sm" iconOnly={true} onClick={() => setAspectRatio(HvacSchemaAspectRatio.MOST)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="24"
          fill="none"
        >
          <path
            stroke="#2C2B2B"
            strokeWidth="2"
            d="M31 1v22H1V1h30Z"
          />

          <path
            fill="#C3C3C3"
            d="M4 4h6v16H4V4Z"
          />

          <path
            fill="#2C2B2B"
            d="M12 4h16v16H12V4Z"
          />
        </svg>
      </Button>

      <Button kind="ghost" size="sm" iconOnly={true} onClick={() => setAspectRatio(HvacSchemaAspectRatio.LEAST)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="24"
          fill="none"
        >
          <path
            stroke="#2C2B2B"
            strokeWidth="2"
            d="M31 1v22H1V1h30Z"
          />

          <path
            fill="#C3C3C3"
            d="M4 4h16v16H4V4Z"
          />

          <path
            fill="#2C2B2B"
            d="M22 4h6v16h-6V4Z"
          />
        </svg>
      </Button>

      <Button kind="ghost" size="sm" iconOnly={true} onClick={() => setAspectRatio(HvacSchemaAspectRatio.FULL)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="24"
          fill="none"
        >
          <path
            stroke="#2C2B2B"
            strokeWidth="2"
            d="M31 1v22H1V1h30Z"
          />

          <path
            fill="#2C2B2B"
            d="M4 4h24v16H4V4Z"
          />
        </svg>
      </Button>
    </div>
  </div>
));
